import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import userReducer from "./Slices/userSlice";
import basketReducer from "./Slices/BasketSlice";
import favoriteReducer from "./Slices/FavoriteSlice";
import dictionaryReducer from "./Slices/dictionarySlice";
import languageReducer from "./Slices/languageSlice";
import themeReducer from "./Slices/ThemeSlice";
import modalReducer from "./Slices/modal";
import channelReducer from "./Slices/channelSlice";
import imageSearchReducer from "./Slices/imageSearchSlice";
import socialAccountsReducer from "./Slices/socialAccountsSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["basket", "favorites", "theme", "channel"],
};

const rootReducer = combineReducers({
  user: userReducer,
  basket: basketReducer,
  favorites: favoriteReducer,
  translations: dictionaryReducer,
  language: languageReducer,
  theme: themeReducer,
  modal: modalReducer,
  channel: channelReducer,
  imageSearch: imageSearchReducer,
  socialAccounts: socialAccountsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
